export default __webpack_public_path__ + "static/char-v-29-zh-Hant-ae059dfa0699fc59567be78caa78167f.mp4";